import React from "react";
import { Star } from "lucide-react";

export function Stars({ rating = 0, size = 14, className = "" }) {
  const full = Math.round(rating);
  return (
    <div className={`flex items-center gap-0.5 ${className}`}>
      {[1, 2, 3, 4, 5].map((i) => (
        <Star key={i} size={size}
          className={i <= full ? "fill-gold text-gold" : "text-slate-300"} />
      ))}
    </div>
  );
}
